// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { nextSaturday as fn } from "../nextSaturday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const nextSaturdayWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default nextSaturdayWithOptions;
